import { matchByIndex } from '../string/string';
const getOs = () => {
    var _a, _b, _c;
    // o iPad 13 vem descrito como Mac OS no seu sistema operacional, porém é
    // possível diferenciar pelos pontos de toque na tela
    const isIPad = navigator.userAgent.includes('Mac OS') && navigator.maxTouchPoints > 1;
    if (((_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.platform) === 'Windows' ||
        navigator.userAgent.includes('Windows NT')) {
        return 'Windows';
    }
    if (((_b = navigator.userAgentData) === null || _b === void 0 ? void 0 : _b.platform) === 'Android' || navigator.userAgent.includes('Android')) {
        return 'Android';
    }
    if (navigator.platform === 'iPhone' || navigator.userAgent.includes('iPhone') || isIPad) {
        return 'IOS';
    }
    if (((_c = navigator.userAgentData) === null || _c === void 0 ? void 0 : _c.platform) === 'macOS' ||
        navigator.userAgent.includes('Mac OS') ||
        /* istanbul ignore next */
        navigator.platform === 'MacIntel') {
        return 'MacOS';
    }
    /* istanbul ignore next */
    return 'Windows';
};
const getIsMobile = () => {
    var _a;
    const os = getOs();
    if (((_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.mobile) || os === 'Android' || os === 'IOS') {
        return true;
    }
    return false;
};
const getUserAgent = () => {
    var _a, _b, _c, _d;
    // A única informação que difere o Chrome do Safari no IOS é a descrição CriOS
    // https://chromium.googlesource.com/chromium/src.git/+/HEAD/docs/ios/user_agent.md
    const isIphoneChrome = navigator.userAgent.includes('CriOS');
    // Contando que existe apenas Chrome e Safari no iPhone, excluindo Chrome,
    // sobra Safari
    const isIphoneSafari = !isIphoneChrome && navigator.platform === 'iPhone';
    const isMacSafari = (navigator.vendor || '').includes('Apple Computer, Inc') &&
        (navigator.platform === 'MacIntel' || navigator.userAgent.includes('Macintosh'));
    if ((_b = (_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.brands) === null || _b === void 0 ? void 0 : _b.some(({ brand }) => brand === 'Microsoft Edge')) {
        return 'Edge';
    }
    if (isIphoneChrome ||
        ((_d = (_c = navigator.userAgentData) === null || _c === void 0 ? void 0 : _c.brands) === null || _d === void 0 ? void 0 : _d.some(({ brand }) => brand === 'Google Chrome'))) {
        return 'Chrome';
    }
    if (navigator.userAgent.includes('Firefox/')) {
        return 'Firefox';
    }
    if (isIphoneSafari || isMacSafari) {
        return 'Safari';
    }
    return 'Internet Explorer';
};
const getBrowserVersion = () => {
    const alias = {
        Chrome: `${getOs() === 'IOS' ? 'CriOS' : 'Chrome'}`,
        Edge: 'Edg',
        Firefox: 'Firefox',
        'Internet Explorer': 'rv',
        Safari: 'Version',
    };
    const browser = alias[getUserAgent()];
    const pattern = new RegExp(browser !== 'rv' ? `${browser}\\/(\\d+)` : `${browser}:(\\d+)`);
    const version = matchByIndex(pattern, navigator.userAgent, 1);
    return version;
};
/**
 * Todas as informações para identificar o aparelho e o navegador estão no objeto `platform`.
 *
 * @category Platform
 *
 * @example
 * ```ts
 * import { platform } from '@ids/tools';
 *
 * // aparelho android e navegador Chrome
 * platform.isMobile // true
 * platform.os // 'Android'
 * platform.userAgent // 'Chrome'
 * platform.userAgentVersion // '112'
 * ```
 */
export const platform = {
    get isMobile() {
        return getIsMobile();
    },
    get os() {
        return getOs();
    },
    get userAgent() {
        return getUserAgent();
    },
    get userAgentVersion() {
        return getBrowserVersion();
    },
};
//# sourceMappingURL=platform.js.map